// Lib Imports
import { format, isBefore, isAfter, isValid, parse, setHours, setMinutes, setMonth, setYear, getHours, getMinutes, getYear } from 'date-fns';
export const getDateInView = (date, bounds) => {
  const current = new Date();
  const [minDate, maxDate] = bounds;
  if (date) {
    return date;
  } else {
    if (minDate && isBefore(current, new Date(minDate))) {
      return new Date(minDate);
    } else if (maxDate && isAfter(current, new Date(maxDate))) {
      return new Date(maxDate);
    }
  }
  return current;
};
export const setTime = (date, {
  hour = 0,
  minute = 0
}) => {
  return setHours(setMinutes(date, minute), hour);
};
export const isValidDate = (date, bounds) => {
  const [minDate, maxDate] = bounds;
  return isValid(date) && isBefore(date, new Date(maxDate)) && isAfter(date, new Date(minDate));
};

// from date object to date string in requested format
export const formatDate = (date, dateFormat) => isValid(date) || isValid(new Date(date)) ? format(new Date(date), dateFormat) : '';

// from date string of given format to date object
export const parseDate = (date, format, bounds) => {
  let parsedDate = parse(date, format, new Date());
  if (!isValidDate(parsedDate, bounds)) {
    format = format.match(/P+p+|./g).map(substring => {
      let char = substring[0];
      if (char === 'P') {
        return 'MM/dd/yyyy';
      } else if (char === 'p') return 'hh:mm a';
      return substring;
    }).join('');
    if (date.length > 0) {
      parsedDate = parse(date, format.slice(0, date.length), new Date());
    }
    if (!isValidDate(parsedDate, bounds)) {
      parsedDate = new Date(date);
    }
  }
  return isValidDate(parsedDate, bounds) ? parsedDate : null;
};
export { setMonth, setYear, getHours, getMinutes, getYear };